import * as React from 'react'
import { InputText } from '../../atoms/input-text/input-text'
import { Button } from '../../atoms/button/button'
import { Context } from '../../../context/app-context'
import CollegeIcon from '../../../assets/images/form/college-icon.svg'
import BellIcon from '../../../assets/images/bell-icon.svg'
import ColeChallengeEc from '../../../assets/images/form/LOGO-COLECHALLENGE.png'
import { useForm } from 'react-hook-form'
import './form-home-step.scss'

export const FormHomeStep = ({ handleNextStep, setFormStep }) => {
  const { userInfo, userParticipation } = React.useContext(Context)
  const hasCollege =
    userParticipation?.nameSchool && userParticipation?.schoolId

  const { register, setValue } = useForm({
    defaultValues: { totalUserKeys: 0, totalSchoolKey: 0 },
  })

  const setKeys = React.useCallback(() => {
    setValue('totalUserKeys', userParticipation?.totalUserKey || 0)

    userParticipation?.totalSchoolKey &&
      setValue('totalSchoolKey', userParticipation?.totalSchoolKey || 0)
  }, [userParticipation, setValue])

  const handleRegisterCollege = () => {
    setFormStep(4)
  }

  React.useEffect(() => {
    setKeys()
  }, [setKeys])

  return (
    <div className="f-form-home">
      <div className="f-form-home__body">
        <h2 className="f-form-home__body__title">Hola {userInfo.name},</h2>

        <div
          className={`f-form-home__body__user-info ${
            !hasCollege ? 'f-form-home__body__user-info--no-college' : ''
          }`}
        >
          {
            process.env.LOCALE === "es-EC" ?
            <h3 className="f-form-home__body__user-info__title">
            AHORA ESTÁS PARTICIPANDO
            </h3>
            :
            <h3 className="f-form-home__body__user-info__title">
            AHORA ESTÁS PARTICIPANDO EN MODO INDIVIDUAL
            </h3>
          }


          <InputText
            name="totalUserKeys"
            color="blue"
            label="CLAVES REGISTRADAS INDIVIDUAL"
            className="f-form-home__body__user-info__field"
            register={register}
            readOnly
          />
        </div>

        {hasCollege && (
          process.env.LOCALE !== "es-EC" ?
          <div className="f-form-home__body__college-info">
            <h3 className="f-form-home__body__college-info__title">
              PARTICIPANDO CON MI COLEGIO
            </h3>
            <p className="f-form-home__body__college-info__description">
              {userParticipation?.nameSchool}
            </p>
            <InputText
              name="totalSchoolKey"
              color="blue"
              label="CLAVES REGISTRADAS COLEGIO"
              className="f-form-home__body__college-info__field"
              register={register}
              readOnly
            />
          </div>
          : ''
        )}

        {!hasCollege && (
          process.env.LOCALE === "es-EC" ?
          ''
          :
          <p className="f-form-home__body__text">
          ¿AÚN NO QUIERES REGISTRAR TU COLEGIO?
          </p>
        )}
        <div
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interacciones - Registro claves',
              category: 'cole challenge',
              action: 'click',
              label: 'ir a registrar claves',
            })
          }}
        >
          <Button
            color="pink"
            type="submit"
            text="IR A REGISTRAR CLAVES"
            className={`f-form-home__body__button ${
              !hasCollege ? 'f-form-home__body__button--no-college' : ''
            }`}
            action={handleNextStep}
          />
        </div>
      </div>
      {
        process.env.LOCALE === "es-EC" ?
        <div className="f-form-home__header" id="register-college">
          <img
            src={ColeChallengeEc}
            alt="icono colegio"
            className="f-form-home__header__logo"
          />
        </div>
        : /* si no es ecuador si muestra el flujo de registrar colegio*/
        <div className="f-form-home__header" id="register-college">
          <img
            src={hasCollege ? BellIcon : CollegeIcon}
            alt="icono colegio"
            className="f-form-home__header__icon"
          />

          {!hasCollege && (
            <h3 className="f-form-home__header__title">
              ¿QUIERES PARTICIPAR <br /> CON TU COLEGIO?
            </h3>
          )}

          <div className="f-form-home__header__description">
            {hasCollege ? (
              <p>
                Ahora vas a participar con tu colegio. Las claves que ingreses te
                sumarán tanto para ti, como para tu colegio.
              </p>
            ) : (
              <p>
                Ahora puedes participar asociandote con tu Colegio o institución
                educativa y sumarle tus claves registradas
              </p>
            )}
          </div>

          {!hasCollege && (
            <div
              onClick={() => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interacciones - Registro Colegio',
                  category: 'cole challenge',
                  action: 'click',
                  label: 'registrar mi colegio',
                })
              }}
            >
              <Button
                color="white"
                type="button"
                onClick={handleRegisterCollege}
                text="REGISTRAR MI COLEGIO"
                className="f-form-home__header__button"
              />
            </div>
          )}
        </div>
      }
    </div>
  )
}
